module.exports = __webpack_public_path__ + "static/media/ico-instagram.54b95027.jpg";